


















 import { Vue, Component } from 'vue-property-decorator';
 import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
 import DatePicker from 'vue2-datepicker';
 import * as moment from 'moment';
 import { mapState, mapGetters } from 'vuex';
 import { StoreState } from '../../../store';

declare interface DateRangeData 
 {
     start_date?: string;
     end_date?  : string;
 }
 
 @Component({
     components: {
         DatePicker
     },  
     mounted ()
     {
         this.$data.maxtodayDate=this.$data.maxDate=new Date(); 
          //this.$store.commit('SET_START_DATE',  null );
         //this.$store.commit('SET_END_DATE',  null);  
     },
     
      computed: {
         ...mapState({
             'startDate': (state: StoreState) => state.reports.filters.startDate,
             'endDate': (state: StoreState) => state.reports.filters.endDate,
         }),
        
     },
    
 })
 export default class DateRangeFilter extends Vue {
     data() {
         return {
             daterange: null,
             start_date: null,
             end_date: null,
             rangeDate:'',
             minDate : '',
             maxDate :'',
             maxtodayDate:'',
         };
     }

     created (){
           if ((this as any).startDate==null  && (this as any).endDate==null ) {
                // var tday= new Date("07/21/2020") ;;//new Date();
                  var tday= new Date();
                 var _tday=new Date();
                 this.$store.commit('SET_START_DATE', tday );
                 this.$store.commit('SET_END_DATE',  tday);
                }
     }

   
     get start_date1(){   
         return (this as any).startDate;
     }


     get end_date1(){
        return (this as any).endDate;
     }

     setmindate(date)
     {
         this.$data.start_date=date.value;
         this.start_date1
         this.$data.minDate = new Date(this.$data.start_date);
          this.$store.commit('SET_START_DATE',  this.$data.start_date );
         this.dateRangeChanged();
     }

     setmaxdate(date)
     {
         this.$data.end_date=date.value;
         this.end_date1;
         this.$data.maxDate = new Date(this.$data.end_date);  
          this.$store.commit('SET_END_DATE',  this.$data.end_date);
         this.dateRangeChanged();
     }

   

      dateRangeChanged() {  
       var  startDate=this.$data.start_date;
       var  endDate=this.$data.end_date;    
         this.$store.commit('SET_CURRENT_FILTERS_RUN', {filtersRun: false});
         //this.$store.commit('SET_START_DATE', startDate );
         //this.$store.commit('SET_END_DATE',  endDate);
         debugger
     }
 }
